import axios from "axios";
import { EvaluationDTO, GetAllEvaluationsResponseDTO } from "./dto";
import { EvaluationService } from "./service";
import { keycloak } from "../../../../lib/keycloak";

export class EvaluationServiceImpl implements EvaluationService {

    public GetAllEvaluation(): Promise<GetAllEvaluationsResponseDTO> {
        return axios.get("/api/pm-evaluation", {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetEvaluationById(id: string): Promise<EvaluationDTO> {
        return axios.get("/api/pm-evaluation/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public CreateEvaluation(data: EvaluationDTO): Promise<void> {
        return axios.post("/api/pm-evaluation",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateEvaluation(data: EvaluationDTO, id: string): Promise<void> {
        return axios.put("/api/pm-evaluation/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteEvaluation(id: string): Promise<void> {
        return axios.delete("/api/pm-evaluation/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}